import Toast from "../../component/toastify/Index";
import axios from "../../axios/interceptor";

export const getCompanyDetails = async () => {
    try {
        const response = await axios.get('/superAdmin/company/getCompanyDetail')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateCompanyDetail = async (payload) => {
    try {
        const response = await axios.put('/superAdmin/company/updateCompanyDetail', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}